import { render, staticRenderFns } from "./ConnectionRequest.vue?vue&type=template&id=f67dc592&"
import script from "./ConnectionRequest.vue?vue&type=script&lang=js&"
export * from "./ConnectionRequest.vue?vue&type=script&lang=js&"
import style0 from "./ConnectionRequest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports